var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfographics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 452,
    viewBox: "0 0 409 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1476_4329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.82 214.93H195.28L228.29 260.36L227.82 214.93Z",
    fill: "#53CFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.64 0H227.82V262.73H408.64V0Z",
    fill: "#53CFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.64 34.1104H227.82V214.93H408.64V34.1104Z",
    fill: "#E9E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.28 27.8495C252.239 27.8495 257.07 23.0187 257.07 17.0595C257.07 11.1004 252.239 6.26953 246.28 6.26953C240.321 6.26953 235.49 11.1004 235.49 17.0595C235.49 23.0187 240.321 27.8495 246.28 27.8495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.22 230.73C253.22 234.56 250.12 237.66 246.29 237.66C242.46 237.66 239.36 234.56 239.36 230.73C239.36 226.9 242.46 223.8 246.29 223.8C250.12 223.8 253.22 226.9 253.22 230.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.291 230.73C272.291 234.56 269.191 237.66 265.361 237.66C261.531 237.66 258.431 234.56 258.431 230.73C258.431 226.9 261.531 223.8 265.361 223.8C269.191 223.8 272.291 226.9 272.291 230.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.36 230.73C291.36 234.56 288.26 237.66 284.43 237.66C280.6 237.66 277.5 234.56 277.5 230.73C277.5 226.9 280.6 223.8 284.43 223.8C288.26 223.8 291.36 226.9 291.36 230.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.431 17.06C388.431 17.92 387.731 18.62 386.871 18.62C386.011 18.62 385.311 17.92 385.311 17.06C385.311 16.2 386.011 15.5 386.871 15.5C387.731 15.5 388.431 16.2 388.431 17.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.511 17.06C393.511 17.92 392.811 18.62 391.951 18.62C391.091 18.62 390.391 17.92 390.391 17.06C390.391 16.2 391.091 15.5 391.951 15.5C392.811 15.5 393.511 16.2 393.511 17.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.58 17.06C398.58 17.92 397.88 18.62 397.02 18.62C396.16 18.62 395.46 17.92 395.46 17.06C395.46 16.2 396.16 15.5 397.02 15.5C397.88 15.5 398.58 16.2 398.58 17.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.08 14.9201C249.08 16.4701 247.83 17.7201 246.28 17.7201C244.73 17.7201 243.48 16.4701 243.48 14.9201C243.48 13.3701 244.73 12.1201 246.28 12.1201C247.83 12.1201 249.08 13.3701 249.08 14.9201Z",
    fill: "#D4D3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69 22.11H241.87C241.9 19.7 243.87 17.75 246.28 17.75C248.69 17.75 250.66 19.7 250.69 22.11Z",
    fill: "#D4D3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.02 62.7998H264.77V153.05H355.02V62.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.689 119.93C370.828 119.93 381.479 109.278 381.479 96.1396C381.479 83.0008 370.828 72.3496 357.689 72.3496C344.551 72.3496 333.899 83.0008 333.899 96.1396C333.899 109.278 344.551 119.93 357.689 119.93Z",
    fill: "#100C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.29 130.08L333.32 157.86L349.35 185.63H317.29H285.22L301.25 157.86L317.29 130.08Z",
    fill: "#B2CDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.91 119.68C270.631 119.68 275.27 115.042 275.27 109.32C275.27 103.598 270.631 98.96 264.91 98.96C259.188 98.96 254.55 103.598 254.55 109.32C254.55 115.042 259.188 119.68 264.91 119.68Z",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.99 162.26V177.86",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.789 170.06H362.189",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.04 51.21H280.06V75.19H304.04V51.21Z",
    fill: "#53CFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.66 242.87L390.44 237.68L382.03 242.87V224.07H398.66V242.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82 290.62H290.53V390.91H390.82V290.62Z",
    fill: "#D4D3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.82 354.82L338.85 372.89L354.88 390.95H322.82H290.75L306.78 372.89L322.82 354.82Z",
    fill: "#E9E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.521 366.61L379.371 378.78L390.231 390.95H368.521H346.811L357.661 378.78L368.521 366.61Z",
    fill: "#E9E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.142 320.885C375.274 316.108 372.318 311.317 367.541 310.185C362.763 309.053 357.973 312.008 356.841 316.786C355.709 321.564 358.664 326.354 363.441 327.486C368.219 328.618 373.01 325.663 374.142 320.885Z",
    fill: "#E9E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33 10.54H27.1602V95.71H112.33V10.54Z",
    fill: "#D4D3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0897 42.4899C54.5963 42.4899 58.2497 38.8366 58.2497 34.3299C58.2497 29.8233 54.5963 26.1699 50.0897 26.1699C45.583 26.1699 41.9297 29.8233 41.9297 34.3299C41.9297 38.8366 45.583 42.4899 50.0897 42.4899Z",
    fill: "#E9E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87 52.29H68.04V83.12H98.87V52.29Z",
    fill: "#E9E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 299.64L258.16 291.61C261.44 289.25 263.59 285.65 264.11 281.64L268.11 251.01C268.54 247.71 266.35 244.63 263.08 243.96L255.94 242.5L229.34 287.91L245.65 298.93",
    fill: "#FF8A5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.46 230.41L196.28 300.64L221.58 276.74L247 299.64L214.74 336.67C199.74 349.94 176.73 348.1 164.02 332.62L124.91 284.95L156.46 230.41Z",
    fill: "#B2CDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.01 395.24L128.18 458.03H80.59L78.94 440.03L72.71 439.97L70.23 458.03H14C17.74 430.86 22.92 394 22.92 394L130.01 395.24Z",
    fill: "#100C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7197 423.91L47.4597 410.1",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2595 436.4L54.2695 436.01",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1797 442.65L72.7097 439.97",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6804 408.28C86.5404 408.69 85.9404 423.04 85.5804 431.76C85.4204 435.68 82.7304 439.03 78.9404 440.03",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0301 445.58L82.5801 442.06",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.58 412.19L127.1 423.71",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8401 223.64C63.2301 217.19 95.6101 211.47 95.6101 211.47L135.58 216.97C147.87 218.66 157.77 227.89 160.31 240.04L163.62 255.83L136.14 397.52C135.42 401.11 132.24 403.66 128.58 403.58L26.4801 396.58C22.5601 396.49 19.5301 393.1 19.8801 389.2L29.5101 244.08C29.6701 236.5 36.0601 226.71 44.8401 223.64Z",
    fill: "#B2CDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75 232.3C95.8104 229.46 90.8704 219.9 93.7104 210.97L104.16 171.79L137.72 184.68L126.08 221.26C123.24 230.2 113.68 235.14 104.75 232.3Z",
    fill: "#FF8A5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.99 132.71C184.99 132.71 196.63 159.28 177.5 164.71C158.37 170.14 167.92 130.32 183.04 132.5",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5198 153.55C92.5198 153.55 89.3698 130.37 98.9098 120.06C98.9098 120.06 111.18 105.48 118.19 122.52C125.2 139.56 109.68 168.09 109.68 168.09C109.68 168.09 99.7298 169.18 92.5198 153.54V153.55Z",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.89 119.58L177.34 191.44C176.22 207.36 162.16 219.22 146.28 217.64L133.64 217.32C107.43 217.76 102.72 188.92 101.68 181.35L101.76 181.89L96.9101 181.7C90.3701 181.44 84.7201 177.06 82.8301 170.79C80.6201 163.42 86.0501 155.98 93.7501 155.85L103.4 155.69L109.11 123.47L183.9 119.59L183.89 119.58Z",
    fill: "#FF8A5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83 139.2C107.83 139.2 104.48 100.97 130.56 103.14C157.85 105.41 158.59 92.5498 183.52 105.88C197.92 113.58 198.46 135.22 186.97 146.25C163.29 169 114.39 154.71 107.82 139.2H107.83Z",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7402 155.85C93.7402 155.85 100.97 155.08 103.98 163.22C104.79 165.41 106.42 167.24 108.62 168.02C114.69 170.19 125.7 169.69 124.88 136.9C124.88 136.9 114.38 119.99 105.55 124.6C96.7102 129.2 93.7402 155.85 93.7402 155.85Z",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7 174.53C135.74 177.08 137.17 179.12 138.91 179.1C140.65 179.08 142.02 176.99 141.99 174.45C141.95 171.9 140.52 169.86 138.78 169.88C137.04 169.9 135.67 171.99 135.7 174.53Z",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.99 175.48C166.03 178.03 167.46 180.07 169.2 180.05C170.94 180.03 172.31 177.94 172.28 175.4C172.24 172.85 170.81 170.81 169.07 170.83C167.33 170.85 165.96 172.94 165.99 175.48Z",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8896 166.93C87.8896 166.93 88.7396 161.53 93.8796 161.4C99.0196 161.27 100.8 168.34 100.8 168.34C98.6597 168.73 97.2396 170.79 97.6396 172.93C98.0296 175.07 100.09 176.49 102.23 176.09",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86 192.54C129.79 193.03 129.36 200.99 135.96 203.4",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82 216.59C127.82 216.59 118.9 216.09 114.1 203.34",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59 165.81C128.59 165.81 133.44 159.3 139.95 161.85",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11 161.66C166.11 161.66 173.48 161.02 174.16 167.09",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.11 177.59L156.71 184.18C156.98 187.46 154.44 190.3 151.14 190.39",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6 234.1L3.16996 287.21C-6.23004 304.11 6.41996 324.8 25.75 324.14L161.76 303.95L167.25 271.82L32.6 234.1Z",
    fill: "#B2CDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8 292.01H217.62C215.58 292.01 214.06 290.12 214.5 288.12L227.36 230.25C227.68 228.79 228.98 227.75 230.48 227.75H260.66C262.7 227.75 264.22 229.64 263.78 231.64L250.92 289.51C250.6 290.97 249.3 292.01 247.8 292.01Z",
    fill: "#131B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4 301.35L163.73 266.23L197.82 253.14L216.39 252.42C217.84 252.36 218.9 253.78 218.42 255.16L217.66 257.38C216.62 260.4 213.77 262.42 210.58 262.41L201.74 262.37L193.64 266.51L194.01 281.14C195.44 288.91 190.16 296.32 182.35 297.52L157.39 301.34L157.4 301.35Z",
    fill: "#FF8A5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83 266.36L65.9199 278.25L68.4599 264.87",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.99 259.46L256.54 278.07L263.89 244.27L252.1 240.48C249.7 239.71 247.07 240.57 245.6 242.62L240.63 249.53C238.47 252.53 238.62 256.61 240.99 259.45V259.46Z",
    fill: "#FF8A5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.83 301.43L24.2695 324.16",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39 312.309L196.29 300.649L201.54 313.759",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.26 247.32L257.08 263.2",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45 242.17L261.42 253.31",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79 281.75L193.35 286.97",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.95 271.649L193.53 275.709",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.42 274.57L65.92 278.25L53.79 284.98",
    stroke: "#131B3D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1476_4329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408.64,
    height: 452.01,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographics);
export default __webpack_public_path__ + "static/media/infographics.084afe93e69cf00575796e263eb809ef.svg";
export { ForwardRef as ReactComponent };